import { render, staticRenderFns } from "./caseInfo.vue?vue&type=template&id=79ca0ad6&"
import script from "./caseInfo.vue?vue&type=script&lang=js&"
export * from "./caseInfo.vue?vue&type=script&lang=js&"
import style0 from "./caseInfo.vue?vue&type=style&index=0&id=79ca0ad6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports